class ImageUtility {
    static isImage(value: string): boolean {
        const imageExtensions = ['.png', '.jpg', '.PNG', '.JPG'];
        return imageExtensions.some(ext => value?.endsWith(ext));
    }
}

export { ImageUtility };
